import { render } from "./CreateSnapshotWizard.vue?vue&type=template&id=2904ecb4&scoped=true"
import script from "./CreateSnapshotWizard.vue?vue&type=script&lang=js"
export * from "./CreateSnapshotWizard.vue?vue&type=script&lang=js"

import "./CreateSnapshotWizard.vue?vue&type=style&index=0&id=2904ecb4&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2904ecb4"]])

export default __exports__